(function () {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getAdministrationDetail': { method:'GET', url:'api/users/:login/administration-detail' },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'},
            'bulkUpdate': { method:'POST', url:'api/users/bulk-update' },
            'exportCsv': {
                method: 'GET',
                url: 'api/users/export/csv',
                responseType: 'arraybuffer',
                cache: false,
                transformResponse: function (data, headersGetter) {
                    return {
                        response: new Blob([data], { type: headersGetter('Content-Type') || 'text/csv;charset=UTF-8' }),
                        fileName: getFileNameFromDisposition(headersGetter('Content-Disposition'))
                    };
                }
            }
        });

        return service;
    }

    function getFileNameFromDisposition(contentDisposition) {
        if (!contentDisposition) {
            return null;
        }
        var match = contentDisposition.match(/filename="(.+)"/);
        return match ? match[1] : null;
    }
})();
